import { useEffect, useState } from 'react';
import { api_getBannersByBannerGroupName } from '~/backend/api_calls';
import { FooterTopBoxesLoader } from '~/components/common/SkeletonLoaders';

export default function FooterTopBoxes() {
	const groupname = 'USPs';
	const [banners, setBanners] = useState(null);

	useEffect(() => {
		api_getBannersByBannerGroupName(groupname)
			.then(json => setBanners(json.items))
			.catch(error => {
				console.log(error);
				setBanners([]);
			});
	}, []);

	if (banners === null) return <FooterTopBoxesLoader />;

	return (
		<div id="footer-top-boxes">
			<div className="content-wrapper">
				<div className="footer-top-boxes-container">
					{banners.map((banner, index) => (
						<div key={index} className="border-linear">
							<div className="footer-box">
								<img src={banner.img1} alt="Shipping Icon" loading="lazy" width="60" height="60" />
								<strong className="title">{banner.tl}</strong>
								<span className="subtitle">{banner.bd}</span>
							</div>
						</div>
					))}
				</div>
			</div>
		</div>
	);
}
